export default {
    getShortString(value, strLength) {

        if (value.length < strLength) {
            return value
        }

        var cutted = value.substring(0, strLength);
        var lastSpaceIndex = cutted.lastIndexOf(' ');
        return cutted.substring(0, lastSpaceIndex) + ' ...';
    },
    formatDate(date) {
        return new Date(date).toLocaleDateString(undefined, {year: 'numeric', month: 'long', day: 'numeric' })
    }
}